import React, { useEffect, useState } from 'react';
import { useUser } from './UserContext';
import { API_BASE_URL } from '../config';
import axios from 'axios';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from './ui/select';
import { ScrollArea } from './ui/scroll-area';
import { FUNCTION_NAMES } from '../constants';
import { fetchWithRetry } from '../utils/tourUtils';

const UserSelector = ({ selectedUser, setSelectedUser }) => {
  const { setSelectedUserPermission } = useUser();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetchWithRetry({
          url: `${API_BASE_URL}/api/post`,
          throwError: true,
          data: {
            function_name: FUNCTION_NAMES.PRISMA,
            operation: 'user.findMany',
            payload: {},
          },
          label: 'user findMany',
        });
        setUsers(response);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="w-full bg-muted py-4">
      <Select
        value={selectedUser}
        onValueChange={value => {
          setSelectedUser(value);
          // const user = users.find(u => u.id === value);
          // setSelectedUserPermission(user?.permission || null);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a user" />
        </SelectTrigger>
        <SelectContent className="max-h-60">
          <ScrollArea className="h-full">
            {users.map(user => (
              <SelectItem key={user.id} value={user.id}>
                {user.firstNameEn} {user.lastNameEn} [{(user.permissions || []).join(', ')}]
              </SelectItem>
            ))}
          </ScrollArea>
        </SelectContent>
      </Select>
    </div>
  );
};

export default UserSelector;
